module.exports = __webpack_public_path__ + "img/icon-logo.afecefd7.svg";